import { FC } from 'react'
import { Dialog, DialogContent } from '@mui/material'
import {
  StyledCloseIcon,
  StyledDialogTitleBox,
  StyledDialogInner,
  StyledDialogTitle,
} from './FileUploaderDialog.styles'
import { FileUploader } from '~/src/components/organisms/FileUploader/FileUploader'
import { useForm } from 'react-hook-form'

interface IFileUploaderDialogProps {
  dialogToggleState: boolean
  dialogTitle: string
  fileText: string
  uploadText: string
  isError: boolean
  isLoading: boolean
  onSaveFile: (file: File) => void
  closeDialog: () => void
}

export const FileUploaderDialog: FC<IFileUploaderDialogProps> = ({
  dialogToggleState,
  dialogTitle,
  fileText,
  uploadText,
  isError,
  isLoading,
  onSaveFile,
  closeDialog,
}): JSX.Element => {
  const { register, handleSubmit } = useForm()

  return (
    <form>
      <Dialog open={dialogToggleState}>
        <StyledDialogInner>
          <StyledDialogTitleBox>
            <StyledDialogTitle>{dialogTitle}</StyledDialogTitle>
            <StyledCloseIcon onClick={closeDialog} />
          </StyledDialogTitleBox>
          <DialogContent>
            <FileUploader
              onSaveFile={onSaveFile}
              onDeleteFile={() => {}}
              fileText={fileText}
              uploadText={uploadText}
              isError={isError}
              isLoading={isLoading}
              optionWidth={'100%'}
            />
          </DialogContent>
        </StyledDialogInner>
      </Dialog>
    </form>
  )
}
